import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FileSpreadsheet } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { bonusReport, bonusReportUrl } from "../../api/bonuses";
import client from "../../api/client";

const CARDS = ["bonuses", "total_amount", "paid_amount", "awaiting_receipt", "rejected", "cancelled"];

// بطاقة التقرير الشهري: إجماليات + تجميع بالفرع + تصدير Excel/PDF.
export const BonusReportCard = ({ filters }) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const params = { branch: filters.branch_id || undefined, month: filters.month || undefined };

  useEffect(() => {
    bonusReport(params).then(setData).catch(() => setData(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.branch_id, filters.month]);

  const download = async (kind) => {
    const res = await client.get(bonusReportUrl({ ...params, kind }), { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `bonuses.${kind}`;
    link.click();
    URL.revokeObjectURL(url);
  };

  if (!data) return null;
  return (
    <NeuCard className="grid gap-3" data-testid="bonus-report-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-base font-black">{t("bonus.report.title")}</h3>
        <div className="flex gap-2">
          <NeuButton data-testid="bonus-export-excel" className="flex items-center gap-1 px-3 py-1 text-xs"
                     onClick={() => download("xlsx")}>
            <FileSpreadsheet className="h-3.5 w-3.5" /> Excel
          </NeuButton>
          <NeuButton data-testid="bonus-export-pdf" className="px-3 py-1 text-xs"
                     onClick={() => download("pdf")}>PDF</NeuButton>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6">
        {CARDS.map((key) => (
          <div key={key} className="rounded-xl bg-secondary/60 p-3" data-testid={`bonus-report-${key}`}>
            <p className="text-[11px] text-muted-foreground">{t(`bonus.report.${key}`)}</p>
            <p className="num text-lg font-black">{data.totals[key]}</p>
          </div>
        ))}
      </div>
      <ul className="grid gap-1">
        {data.by_branch.map((row) => (
          <li key={row.key} className="flex justify-between border-b border-border/30 py-1 text-xs">
            <span>{row.label}</span>
            <span className="num font-bold">{row.amount} · {row.count}</span>
          </li>
        ))}
      </ul>
    </NeuCard>
  );
};
